import { render } from "./PointShop.vue?vue&type=template&id=313ce1f7&scoped=true"
import script from "./PointShop.vue?vue&type=script&lang=js"
export * from "./PointShop.vue?vue&type=script&lang=js"

import "./PointShop.vue?vue&type=style&index=0&id=313ce1f7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313ce1f7"]])

export default __exports__